export default "__VITE_ASSET__ZfEAniW3__"